import * as actionTypes from './actionTypes';

const initialState = {
	unitsOfMeasurement: [],
	isLoading: false,
	error: null
};

const unitsOfMeasurementReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.START_FETCHING_UNITS_OF_MEASUREMENT:
			return {
				...state,
				isLoading: true,
				error: null
			};
		case actionTypes.GET_UNITS_OF_MEASUREMENT_SUCCESS:
			return {
				...state,
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
				isLoading: false,
				error: null
			};
		case actionTypes.GET_UNITS_OF_MEASUREMENT_ERROR:
			return {
				...state,
				isLoading: false,
				error: action.payload
			};
		case actionTypes.REMOVE_UNITS_OF_MEASUREMENT:
			return {
				...state,
				unitsOfMeasurement: [],
				isLoading: false,
				error: null
			};
		default:
			return state;
	}
};

export default unitsOfMeasurementReducer;
